// removed by extract-text-webpack-plugin
module.exports = {"timer":"timer__A0WlG","divider":"divider__2H1Sy"};


//////////////////
// WEBPACK FOOTER
// ./components/countdown/styles/ThankYouCountdownTimerStyle.scss
// module id = FQJ3
// module chunks = 1